// import { useState } from 'react';
//
// export function useKeyDown() {
//   const [count, setCount] = useState(0)
//   const increment = () => setCount((c) => c + 1)
//   return { count, increment }
// }

import { useEffect } from 'react'

/**
 * useKeyDown
 * @param {string, number} key - the name of the key to respond to, compared against event.key or event.keyCode
 * @param {function} action - the action to perform on key down
 * @param {boolean} active
 */

export const useKeyDown = (
    key: number | string,
    action: (e: KeyboardEvent) => void,
    active = true
) => {
  useEffect(() => {
    const onKeyup = (e: KeyboardEvent) => {
      if (!active) return
      if (e.key === key || e.keyCode === key) return action?.(e)
    }

    window.addEventListener('keydown', onKeyup)
    return () => window.removeEventListener('keydown', onKeyup)
  }, [action, key, active])
}